import { render } from "./functional_information_ConsequencesByIdView.vue?vue&type=template&id=27140d2b&scoped=true"
import script from "./functional_information_ConsequencesByIdView.vue?vue&type=script&lang=js"
export * from "./functional_information_ConsequencesByIdView.vue?vue&type=script&lang=js"

import "./functional_information_ConsequencesByIdView.vue?vue&type=style&index=0&id=27140d2b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27140d2b"]])

export default __exports__